export default __webpack_public_path__ + "static/media/microsoft_icon.28d8f59e.svg";